
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M243.577 506.461c-7.065-7.868-173.004-194.146-173.004-321.035C70.574 83.182 153.756 0 256.001 0s185.426 83.182 185.426 185.426c0 126.888-165.939 313.167-173.004 321.035-6.637 7.393-18.224 7.378-24.846 0z","fill":"#ff5752"}}),_c('path',{attrs:{"d":"M441.426 185.426C441.426 83.182 358.244 0 256.001 0v512c4.552 0 9.106-1.843 12.423-5.539 7.063-7.867 173.002-194.146 173.002-321.035z","fill":"#db3a3c"}}),_c('path',{attrs:{"d":"M256.001 278.719c-51.442 0-93.291-41.851-93.291-93.293s41.851-93.293 93.291-93.293 93.291 41.851 93.291 93.293-41.851 93.293-93.291 93.293z","fill":"#efefef"}}),_c('path',{attrs:{"d":"M256.001 92.134v186.585c51.442 0 93.291-41.851 93.291-93.293s-41.851-93.292-93.291-93.292z","fill":"#c5d8df"}})])
          )
        }
      }
    